/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { TIMED_ENTRY_PREFIX } from '../constants';

export const FETCH_TOURS_BY_FACILITY = `${TIMED_ENTRY_PREFIX}FETCH_TOURS_BY_FACILITY`;
export const FETCH_TOURS_BY_FACILITY_SUCCESS = `${TIMED_ENTRY_PREFIX}FETCH_TOURS_BY_FACILITY_SUCCESS`;
export const FETCH_TOURS_BY_FACILITY_ERROR = `${TIMED_ENTRY_PREFIX}FETCH_TOURS_BY_FACILITY_ERROR`;
export const SET_FETCH_TOURS_BY_FACILITY_STATUS = `${TIMED_ENTRY_PREFIX}SET_FETCH_TOURS_BY_FACILITY_STATUS`;
export const SET_TOUR_SELECTED_CARD = `${TIMED_ENTRY_PREFIX}SET_TOUR_SELECTED_CARD`;

export function fetchToursByFacilitySuccess(data) {
    return {
        type: FETCH_TOURS_BY_FACILITY_SUCCESS,
        payload: data,
    };
}

export function fetchToursByFacilityError(error) {
    return {
        type: FETCH_TOURS_BY_FACILITY_ERROR,
        payload: error,
    };
}

export function setFetchToursByFacilityStatus(status) {
    return {
        type: SET_FETCH_TOURS_BY_FACILITY_STATUS,
        payload: status,
    };
}

export function fetchToursByFacility(facilityId) {
    return {
        type: FETCH_TOURS_BY_FACILITY,
        payload: facilityId,
    };
}

export function setTourSelectedCard(tourId) {
    return {
        type: SET_TOUR_SELECTED_CARD,
        payload: tourId,
    };
}
